import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../../globals";
import { ConfigurationServices } from "../../../services";
import { TranslateService } from '@ngx-translate/core'
import { StaticsServices } from '../../../../services/statics';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationVariationAddElementsPage } from './configuration-variation-add-elements/configuration-variation-add-elements';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ArticleViewPage } from '../../../../articles/articles-view/article-view';

/**
 * Generated class for the ConfigurationVariationsCreateInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-variations-create-info',
    templateUrl: 'configuration-variations-create-info.html',
})
export class ConfigurationVariationsCreateInfoPage {

    public form: FormGroup;
    update_state: boolean = false;
    dish: any;
    ingredient: any;
    product: any;
    type: any;
    variation: any;
    elements_containing_variation: any;
    //datatable
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public fb: FormBuilder,
        private toastCtrl: ToastController,
        public globals: Globals,
        private alertCtrl: AlertController,
        public configurationServices: ConfigurationServices,
        public translate: TranslateService,
        private staticsServices: StaticsServices,
        public http: HttpClient) {

        //Params
        this.update_state = this.navParams.get('update_state');
        this.type = this.navParams.get('type');

        if (this.update_state) {
            this.globals.GAtrackView('Configuration', 'Configuration - Variation - View ', this.globals.restaurant.email, 'View', 'View variation', 'Configuration', '');
            this.variation = this.navParams.get('variation');
            this.getElementsContainingVariation();
            if (this.type == 'dish') {
                this.form = fb.group({
                    name: [this.variation.name, Validators.compose([Validators.required])],
                    measurement: [this.variation.measurement],
                    price: [this.variation.price, Validators.compose([Validators.required])],
                    quantity: [this.variation.quantity, Validators.compose([Validators.required])],
                    type: [this.variation.type, Validators.compose([Validators.required])],
                    uid_element: [this.variation.uid_element],
                });
            } else {
                this.form = fb.group({
                    name: [this.variation.name, Validators.compose([Validators.required])],
                    measurement: [this.variation.measurement, Validators.compose([Validators.required])],
                    price: [this.variation.price, Validators.compose([Validators.required])],
                    quantity: [this.variation.quantity, Validators.compose([Validators.required])],
                    type: [this.variation.type, Validators.compose([Validators.required])],
                    uid_element: [this.variation.uid_element],
                });
            }

        } else {
            if (this.type == 'dish') {
                this.dish = this.navParams.get('dish');

                this.form = fb.group({
                    name: [this.dish.name_es, Validators.compose([Validators.required])],
                    measurement: [''],
                    price: [0, Validators.compose([Validators.required])],
                    quantity: ['', Validators.compose([Validators.required])],
                    type: ['dish', Validators.compose([Validators.required])],
                    uid_element: [this.dish.UID],
                });
            } else if (this.type == 'ingredient') {
                this.ingredient = this.navParams.get('ingredient');

                this.form = fb.group({
                    name: [this.ingredient.name, Validators.compose([Validators.required])],
                    measurement: ['', Validators.compose([Validators.required])],
                    price: [0, Validators.compose([Validators.required])],
                    quantity: ['', Validators.compose([Validators.required])],
                    type: ['ingredient', Validators.compose([Validators.required])],
                    uid_element: [this.ingredient.UID],
                });
            } else {
                this.product = this.navParams.get('product');

                this.form = fb.group({
                    name: [this.product.name, Validators.compose([Validators.required])],
                    measurement: ['', Validators.compose([Validators.required])],
                    price: [0, Validators.compose([Validators.required])],
                    quantity: ['', Validators.compose([Validators.required])],
                    type: ['product', Validators.compose([Validators.required])],
                    uid_element: [this.product.UID],
                });
            }
        }
    }
    ionViewWillEnter() {

    }

    submit() {
        if (this.form.valid) {
            if (!this.update_state) {
                this.insert();
            } else {
                this.update();
            }
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('config-variations-create-info-introduce-nombre-variacion'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    insert() {
        this.configurationServices.afs.collection('variations').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'name': this.form.value.name,
            'measurement': this.form.value.measurement,
            'price': this.form.value.price,
            'quantity': this.form.value.quantity,
            'type': this.form.value.type,
            'uid_element': this.form.value.uid_element,
        }).then(doc => {
            this.globals.GAtrackView('Configuration', 'Configuration - Variation - Name - Create ', this.globals.restaurant.email, 'Create/Update', 'Create variation name', 'Configuration', this.form.value.name);
            //this.navCtrl.push(ConfigurationVariationsPage);
            if (this.navCtrl.getViews().findIndex(x => x.name === 'ArticleViewPage') != -1) {
                this.navCtrl.popTo(this.navCtrl.getByIndex(2));
            } else {
                this.navCtrl.popTo(this.navCtrl.getByIndex(0)).then(doc => {
                    this.configurationServices.getVariations(this.globals.restaurant_uid);
                    this.configurationServices.getPagesVariations();
                });
            }
        });
    }

    update() {
        this.configurationServices.afs.collection('variations').doc(this.variation.UID).update({
            'name': this.form.value.name,
            'measurement': this.form.value.measurement,
            'price': this.form.value.price,
            'quantity': this.form.value.quantity,
            'type': this.form.value.type,
            'uid_element': this.form.value.uid_element,
        }).then(() => {
            this.globals.GAtrackView('Configuration', 'Configuration - Variation - Name - Update ', this.globals.restaurant.email, 'Create/Update', 'Update variation name', 'Configuration', this.form.value.name);
            //statics wait true
            this.staticsServices.changeStateStaticWait(true);
            this.navCtrl.pop();
        });
    }

    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-variacion'),
            message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.deleteVariation();
                    }
                }
            ]
        });
        alert.present();
    }

    async deleteVariation() {
        this.globals.GAtrackView('Configuration', 'Configuration - Variation - Delete ', this.globals.restaurant.email, 'Delete', 'Delete variation', 'Configuration', this.variation.name);
        //llamar statics
        this.deletesAndStatics(this.variation.UID);
        //borrar de firebase
        await this.configurationServices.afs.doc('variations/' + this.variation.UID).delete();
        this.navCtrl.pop();
    }

    async deletesAndStatics(uid) {
        this.staticsServices.changeStateStaticWait(true);
        this.staticsServices.addDeleteStaticToQueue(uid, 'delete_variation_update');
    }

    addVariationToElements() {
        this.navCtrl.push(ConfigurationVariationAddElementsPage, {
            "variation": this.variation
        });
    }
    async getElementsContainingVariation() {
        this.configurationServices.dishes_products_array_tmp = [];
        const body = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('variation_uid', this.variation.UID);
        await this.http.post(this.globals.analytics_path + 'get_dishes_products_containing_variation', body).subscribe(async data => {
            this.configurationServices.dishes_products_array_tmp = data['list'];
        }, err => { });
    }

    clickElement(event) {
        if (event.type == 'click') {
            this.globals.side_menu_active = 'dish';
            this.navCtrl.push(ArticleViewPage, {
                article_uid: event.row.UID,
                article_type: event.row.type
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-variations/configuration-variations-create/configuration-variations-create-info/configuration-variations-create-info.ts